import {PatientCommandParams} from "./PatientCommandParams";
import {Command} from "./Command";
import { NCZIExtension } from '../Interfaces/ncziTypes';

export type GetPatientDPNListParams = PatientCommandParams & {
    page?: number
    perPage?: number
    includeCancelled?: boolean
    includeHistory?: boolean
    withoutValidityEnd?: boolean
    confirmationId?: NCZIExtension
    createdFrom?: string
    createdTo?: string
    endValidityFrom?: string
    endValidityTo?: string
    startValidityFrom?: string
    startValidityTo?: string
};

export const GetPatientDPNList = (params: GetPatientDPNListParams): Command => {
    return {
        operation: 'VyhladajPotvrdenieDPN_v1',
        params
    }
}